// Detect the isolated Guangzhou warehouse portal mode.
// Activated automatically when the app is opened from the dedicated warehouse
// host (set REACT_APP_WAREHOUSE_HOST on the separate deployment), or manually
// for testing via the ?warehouse=1 query param (persisted per tab).
export function isWarehouseMode() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("warehouse") === "1") sessionStorage.setItem("wh_mode", "1");
    if (params.get("warehouse") === "0") sessionStorage.removeItem("wh_mode");
  } catch (_) {}
  const raw = (process.env.REACT_APP_WAREHOUSE_HOST || "").trim().replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  let byHost = false;
  try { byHost = Boolean(raw) && (window.location.hostname === raw || window.location.hostname.endsWith(raw)); } catch (_) {}
  let byPath = false;
  try { byPath = window.location.pathname.startsWith("/w-a7f3c9e2"); } catch (_) {}
  let byFlag = false;
  try { byFlag = sessionStorage.getItem("wh_mode") === "1"; } catch (_) {}
  return byHost || byPath || byFlag;
}
